declare const app: ng.IModule, angular: ng.IAngularStatic, document, parseInt;
export class productPriceController {
  ajaxLoading: boolean = true;
  item: any;
  bestVendor: any;
  addToCart: any;
  editPriceUrl;
  product: any;
  constructor(
    private $salabelItem,
    private $state: ng.ui.IStateService,
    private $user,
    private $mdDialog,
    private $timeout,
    private $rootScope,
    private MyConstant,
    private $mPath,
    private $location: ng.ILocationService
  ) {
    "ngInject";

    $rootScope.$on("showVendorInfo", (event, obj) => {
      this.showVendorInfo(obj.ev, obj.type, obj.vendorId);
    });
  }
  makeUrl(product) {
    this.$mPath.get().then(response => { });
  }
  $onInit() {
    this.$salabelItem.get(
      { productID: this.$state.params.pID, RowsPerPage: 1 },
      {},
      res => {
        this.$mPath.get().then(modulePath => {
          this.$user.getInfo().then(user => {
            if (this.MyConstant.Type == "bazaryab") {
              this.editPriceUrl = `${modulePath.StoreVendorAdmin}/UserId/${
                user.data.UserID
                }/manageProduct/ProductID/${this.$state.params.pID}`;
            } else {
              this.editPriceUrl = `${modulePath.StoreAdmin}/UserId/${
                user.data.UserID
                }/manageProduct/ProductID/${this.$state.params.pID}`;
            }
          });
          if (res.VendorSalableItemServiceModels[0]) {
            this.bestVendor = res.VendorSalableItemServiceModels[0];
            this.$rootScope.$emit("$bestvendor", this.bestVendor);
            this.$rootScope.bestVendor = res.VendorSalableItemServiceModels[0];
            this.bestVendor.href = `${
              modulePath.StoreVendorProductList
              }/VendorID/${this.bestVendor.VendorID}`;
            this.bestVendor.AbstractSalableItems &&
              this.bestVendor.AbstractSalableItems.map(item => {
                item.count = item.MinimumOrderCount
                  ? angular.copy(item.MinimumOrderCount)
                  : 1;
              });
          }
          this.ajaxLoading = false;
        });
      }
    );
  }
  moresalabelInfo(ev, desc) {
    this.$mdDialog.show({
      controller: function ($mdDialog) {
        "ngInject";
        this.description = desc;
        this.cancel = () => {
          $mdDialog.hide();
        };
      },
      controllerAs: "dialog",
      templateUrl: `${
        this.MyConstant.TemplateUrl
        }modal/salabelItem-MoreInfo.html`,
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: true
    });
  }
  edit_price(SalableItemID, ev, $index) {
    let productId = this.product.ProductID;
    this.$mdDialog.show({
      controller: function () {
        this.SalableItem = {
          productId,
          SalableItemID
        }
      },
      controllerAs: 'dialog',
      template: '<div class="form-price-containner"> <management-price-form salable-item="dialog.SalableItem"></management-price-form></div>',
      parent: angular.element(document.body),
      // targetEvent: ev,
      fullscreen: true,
      clickOutsideToClose: true,
    }).then(
      response => {
        this.$state.reload()
      }
    )
  }
  remove_price(SalableItemID, ev, $index) {
    var confirm = this.$mdDialog.ecb_confirm()
      .title('آیا از حذف این مورد اطمینان دارد؟')
      .textContent(`در صورت تایید این تخفیف حذف خواهد شد.`)
      .targetEvent(ev)
      .ok('بله حذف کن!')
      .cancel('منصرف شدم');

    this.$mdDialog.show(confirm).then(() => {
      this.$salabelItem.remove({ SalableItemID }, () => {
        this.bestVendor.AbstractSalableItems.splice($index, 1);
      })
    })

  }
  add_new_price() {
    let productId = this.product.ProductID;
    this.$mdDialog.show({
      controller: function () {
        this.SalableItem = {
          productId,
        }
      },
      controllerAs: 'dialog',
      template: '<div class="form-price-containner"> <management-price-form salable-item="dialog.SalableItem"></management-price-form></div>',
      parent: angular.element(document.body),
      // targetEvent: ev,
      fullscreen: true,
      clickOutsideToClose: true,
    }).then(
      response => {
        this.$state.reload()
      }
    )
  }
  changeCount(item) {
    let isNumber = parseInt(item.count);
    if (!isNumber || isNumber < item.MinimumOrderCount) {
      item.count = angular.copy(item.MinimumOrderCount);
      this.setCountNotify(item);
    }
    item.count = parseInt(item.count);
  }

  increaseCount(item) {
    item.count += 1;
  }

  decreaseCount(item) {
    if (item.count > item.MinimumOrderCount) {
      item.count -= 1;
    } else {
      this.setCountNotify(item);
    }
  }

  addToCartFn(vendor, salabelItem) {
    this.addToCart({ vendor: vendor, salabelItem: salabelItem });
  }
  showVendorInfo(ev, type, vendorId) {
    this.$mdDialog.show({
      controller: function ($mdDialog, $vendorInfo, $state, $filter, $mdMedia) {
        "ngInject";
        this.type = type;
        this.$mdMedia = $mdMedia;
        switch (type) {
          case "payment":
            this.title = "شرایط پرداخت فروشگاه";
            $vendorInfo.payment(
              { productId: $state.params.pID, vendorId: vendorId },
              response => {
                response.map(item => {
                  item.Title = $filter("translates")(
                    item.PaymentMethodName,
                    "FA"
                  );
                });
                this.items = response;
              }
            );
            break;
          case "shippment":
            this.title = "شرایط حمل فروشگاه";
            $vendorInfo.shippment(
              { productId: $state.params.pID, vendorId: vendorId },
              response => {
                response.map(item => {
                  item.Title = item.TransportTypeName;
                  item.subTitle = `مدت زمان ارسال :‌${item.DelayHours}`;
                });
                this.items = response;
              }
            );
            break;
          case "warranty":
            this.title = "شرایط ضمانت فروشگاه";
            $vendorInfo.warranty(
              { productId: $state.params.pID, vendorId: vendorId },
              response => {
                response.map(item => {
                  item.subTitle = `تعداد ماه گارانتی :‌${item.WarantyMonth}`;
                });
                this.items = response;
              }
            );
            break;
        }
        this.cancel = () => {
          $mdDialog.hide();
        };
      },
      controllerAs: "dialog",
      template: `<md-dialog ng-class="{'md-dialog-fullscreen':dialog.$mdMedia('max-width: 600px')}" class="vendor-more-info" aria-label="" flex="70">
	<md-toolbar>
		<div class="md-toolbar-tools">
			<h2>{{dialog.title}}</h2>
			<span flex></span>
			<md-button class="md-icon-button" ng-click="dialog.cancel()">
				<md-icon class="zmdi zmdi-close" aria-label="Close dialog"></md-icon>
			</md-button>
		</div>
	</md-toolbar>

	<md-dialog-content>
		<spn-loading ng-if="!dialog.items"></spn-loading>
		<div class="md-dialog-content">
			<md-card ng-repeat="item in dialog.items">
				<md-card-header class="md-primary">
					<md-card-avatar>
						<md-icon class="md-avatar-icon zmdi" ng-class="{'zmdi-truck':dialog.type=='shippment','zmdi-card':dialog.type == 'payment','zmdi-swap':dialog.type=='warranty'}"></md-icon>
					</md-card-avatar>
					<md-card-header-text>
						<span class="md-title" ng-class="{'single-title':dialog.type=='payment'}">{{::item.Title}}</span>
						<span ng-show="item.subTitle" class="md-subhead">{{::item.subTitle}}</span>
					</md-card-header-text>
				</md-card-header>
				<md-card-content>
					<p>
						{{::item.Description}}
					</p>
				</md-card-content>
			</md-card>
			<div class="no-exist card-panel" ng-if="dialog.items.length == 0">
				موردی یافت نشد.
			</div>
		</div>
	</md-dialog-content>

</md-dialog>`,
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: true
    });
  }
  private setCountNotify(item) {
    item.countNotify = `کمترین تعداد ممکن برای افزودن به سبد خرید ${
      item.MinimumOrderCount
      } عدد می باشد`;
    this.$timeout(() => {
      item.countNotify = null;
    }, 4000);
  }
}



// WEBPACK FOOTER //
// ./src/components/product-price/product-price.controller.ts